import { Box, BoxProps } from "@chakra-ui/react";

export function PasswordIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="26"
        height="27"
        viewBox="0 0 26 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.70898 10.2493C2.74197 9.37773 2.83909 8.49076 3.00075 7.59533C3.1213 6.92758 3.18157 6.5937 3.38741 6.36522C3.59325 6.13674 4.10187 5.97466 5.11911 5.65049C7.62089 4.85326 9.73628 2.66602 12.9987 2.66602C16.2613 2.66602 18.3791 4.85342 20.8819 5.65058C21.8991 5.97457 22.4076 6.13656 22.6135 6.36504C22.8194 6.59353 22.8797 6.92746 23.0003 7.59532C23.162 8.49076 23.2592 9.37773 23.2923 10.2493M21.0661 18.916C19.6361 21.1072 17.526 22.8566 14.7499 23.9183C14.0274 24.1945 13.6662 24.3327 13.0023 24.3327C12.3384 24.3327 11.9772 24.1946 11.2547 23.9183C8.47837 22.8567 6.36768 21.1072 4.93704 18.916"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.20898 13.5L10.2923 14.5833M10.2923 14.5833L11.3757 15.6667M10.2923 14.5833L11.3757 13.5M10.2923 14.5833L9.20898 15.6667"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
        <path
          d="M3.79102 13.5L4.87435 14.5833M4.87435 14.5833L5.95768 15.6667M4.87435 14.5833L5.95768 13.5M4.87435 14.5833L3.79102 15.6667"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
        <path
          d="M14.625 13.5L15.7083 14.5833M15.7083 14.5833L16.7917 15.6667M15.7083 14.5833L16.7917 13.5M15.7083 14.5833L14.625 15.6667"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
        <path
          d="M20.041 13.5L21.1243 14.5833M21.1243 14.5833L22.2077 15.6667M21.1243 14.5833L22.2077 13.5M21.1243 14.5833L20.041 15.6667"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
      </svg>
    </Box>
  );
}
